var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2640_67271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.503 0.0416409C13.0195 0.0390366 8.70812 1.81358 5.46838 4.99489C2.22901 8.1761 0.311703 12.5181 0.116632 17.1152C-0.0787642 21.712 1.46376 26.2087 4.42147 29.6669L16.8858 44.6672C17.0399 44.8525 17.2653 44.9589 17.5028 44.9589C17.7402 44.9589 17.9657 44.8525 18.1198 44.6672L30.2519 30.0497C33.3408 26.6352 35.0069 22.1169 34.8949 17.459C34.7829 12.8011 32.9015 8.37249 29.6523 5.1187C26.4031 1.86454 22.0432 0.0423074 17.5035 0.0412598L17.503 0.0416409Z",
    fill: "#35659C"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2640_67271)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.932 27.6111C15.2457 27.6111 15.5 27.3568 15.5 27.0431V23.1791C15.5 22.8654 15.7543 22.6111 16.068 22.6111H19.932C20.2457 22.6111 20.5 22.8654 20.5 23.1791V27.0431C20.5 27.3568 20.7543 27.6111 21.068 27.6111H23.682C23.9957 27.6111 24.25 27.3568 24.25 27.0431V19.4291C24.25 19.1154 24.5043 18.8611 24.818 18.8611H26.4883C27.0128 18.8611 27.257 18.211 26.8623 17.8656L18.374 10.4384C18.1599 10.251 17.8401 10.251 17.626 10.4384L9.13766 17.8656C8.74296 18.211 8.98722 18.8611 9.51169 18.8611H11.182C11.4957 18.8611 11.75 19.1154 11.75 19.4291V27.0431C11.75 27.3568 12.0043 27.6111 12.318 27.6111H14.932Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2640_67271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 45,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2640_67271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealty);
export default __webpack_public_path__ + "static/media/realty.bbf67bcad9cd426fde6aae13dcc8e865.svg";
export { ForwardRef as ReactComponent };